import gql from "graphql-tag";
import { getListQuery, getSingleQuery } from "../queries";
import jobsSchema from "../schemas/jobs";

export default {
  gqlType: "Job",
  fields: [
    "queueName",
    "commandName",
    "status",
    "timestamp",
    "email",
    "fileURL",
  ],
  searchPlaceholder: "Search by command name",
  listQuery: getListQuery("Job"),
  singleQuery: getSingleQuery("Job"),
  ...jobsSchema,
  removeJobMutation: gql`
    mutation removeJob($jobId: ID) {
      removeJob(input: { jobId: $jobId }) {
        status
      }
    }
  `,
  transform: (n) => {
    return {
      ...n,
      commandName: n.name,
      timestamp: new Date(+n.timestamp).toLocaleString(),
    };
  },
}
